// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';
import { DimensionOut } from './dimensionOut.zod.ts';
import { IndustryOut } from './industryOut.zod.ts';

export const IdeaCatalogueOut = zod.object({
  "dimensions": zod.array(DimensionOut),
  "dispositions": zod.array(zod.enum(['active', 'parked', 'archived'])),
  "industries": zod.array(IndustryOut),
  "matrix_threshold": zod.int()
});

export type IdeaCatalogueOut = zod.input<typeof IdeaCatalogueOut>;
export type IdeaCatalogueOutOutput = zod.output<typeof IdeaCatalogueOut>;
